function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import { spin, pulse } from '../styles/animations';
import { themify } from '../styles/mixins';
const Dots = styled.div.withConfig({
  displayName: "Spinner__Dots",
  componentId: "sc-1aqj3ot-0"
})(["display:inline-block;width:", ";height:", ";margin:", ";text-align:center;animation:", " 2s infinite linear both;z-index:1000;"], x => x.width, x => x.width, x => `calc(${x.width} / 3)`, spin);
const DotOne = styled.div.withConfig({
  displayName: "Spinner__DotOne",
  componentId: "sc-1aqj3ot-1"
})(["position:absolute;top:0;display:inline-block;width:60%;height:60%;border-radius:100%;background:", ";animation:", " 2s infinite ease-in-out both;"], x => x.color, pulse);
const DotTwo = styled(DotOne).withConfig({
  displayName: "Spinner__DotTwo",
  componentId: "sc-1aqj3ot-2"
})(["top:auto;bottom:0;animation-delay:-1s;"]);
export const Spinner = (_ref) => {
  let {
    width = '36px',
    color = 'green'
  } = _ref,
      props = _objectWithoutProperties(_ref, ["width", "color"]);

  return /*#__PURE__*/React.createElement(Dots, _extends({
    width: width
  }, props), /*#__PURE__*/React.createElement(DotOne, {
    color: themify(color)
  }), /*#__PURE__*/React.createElement(DotTwo, {
    color: themify(color)
  }));
};